export default __webpack_public_path__ + "static/media/bp7.36a70451.png";